import { Component, OnInit, Input, Output, ViewEncapsulation, enableProdMode } from '@angular/core';
import { EventEmitter }  from '@angular/core';

@Component({
  selector: '[kt-menu-card]',
  templateUrl: './menu-card.component.html',
  styleUrls: ['./menu-card.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class MenuCardComponent implements OnInit {

  @Input()
  menuTitle : string = '' ;

  @Input()
  menuSubTitle : string = '' ;

  @Input()
  menuButtonTitle : string = '' ;

  @Input()
  menuIcon : string = 'flaticon-analytics';
  
  @Output('onButtonClick')
  onButtonClick =  new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    
  }

  btnClick() : void {
    //alert("Selam");
    this.onButtonClick.emit(null);
  }

}
